import { useEffect, useState } from "react";

import { getAlertedProductsPage } from "../../../entities/alerted-product";

export const useAddAlertModal = ({ isOpen, appliedFilters, extraFilters = null }) => {
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setAllRows([]);
      return;
    }
    if (!appliedFilters) return;

    let cancelled = false;
    // Una sola petición con un tamaño amplio: la modal filtra en cliente sobre
    // todo el conjunto, así que evitamos recorrer páginas una a una.
    const MODAL_PAGE_SIZE = 1000;
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const result = await getAlertedProductsPage({
          ...appliedFilters,
          ...extraFilters,
          page: 1,
          pageSize: MODAL_PAGE_SIZE,
        });
        if (!cancelled) setAllRows(result.rows ?? []);
      } catch {
        if (!cancelled) setAllRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchProducts();
    return () => { cancelled = true; };
  }, [isOpen, appliedFilters, extraFilters]);

  return { allRows, loading };
};